export { ehrIntegrationRelations } from './ehrIntegrationRelations';
export { healthRecordUploadRelations } from './healthRecordUploadRelations';
